var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "nav",
    {
      staticClass:
        "chat-indice-artefatos-compacta d-flex flex-column align-center",
      style: _vm.estilo,
      attrs: {
        "aria-label": _vm.rotulo,
        "data-test": "chat-indice-artefatos-compacta"
      }
    },
    [
      _c(
        "button",
        {
          staticClass:
            "chat-indice-artefatos-compacta__acao d-inline-flex align-center justify-center flex-shrink-0 mb-1",
          attrs: {
            type: "button",
            "aria-label": _vm.rotuloExpandir,
            title: _vm.rotuloExpandir,
            "data-test": "chat-indice-artefatos-compacta-expandir"
          },
          on: { click: _vm.expandir }
        },
        [
          _c("icon-svg", {
            attrs: {
              name: _vm.ICONE_DE_EXPANDIR,
              size: _vm.TAMANHO_DO_ICONE_DO_TOPO,
              color: "var(--neutral-600)"
            }
          })
        ],
        1
      ),
      _c(
        "ul",
        {
          staticClass:
            "chat-indice-artefatos-compacta__lista d-flex flex-column align-center",
          style: _vm.estiloDaLista,
          attrs: { "data-test": "chat-indice-artefatos-compacta-lista" }
        },
        _vm._l(_vm.linhas, function(linha) {
          return _c(
            "li",
            { key: linha.identidade },
            [
              _c(
                "v-tooltip",
                {
                  attrs: { left: "" },
                  scopedSlots: _vm._u(
                    [
                      {
                        key: "activator",
                        fn: function(ref) {
                          var on = ref.on
                          var attrs = ref.attrs
                          return [
                            _c(
                              "button",
                              _vm._g(
                                _vm._b(
                                  {
                                    staticClass:
                                      "chat-indice-artefatos-compacta__tile d-inline-flex align-center justify-center",
                                    attrs: {
                                      type: "button",
                                      "aria-label": linha.titulo,
                                      "aria-current": linha.ativa
                                        ? "true"
                                        : null,
                                      "data-test":
                                        "chat-indice-artefatos-compacta-botao"
                                    },
                                    on: {
                                      click: function($event) {
                                        return _vm.escolher(linha)
                                      },
                                      mouseenter: function($event) {
                                        _vm.linhaEmHover = linha.identidade
                                      },
                                      mouseleave: function($event) {
                                        _vm.linhaEmHover = null
                                      }
                                    }
                                  },
                                  "button",
                                  attrs,
                                  false
                                ),
                                on
                              ),
                              [
                                _c("icon-svg", {
                                  staticClass: "navbar-main-icon",
                                  class: _vm.classesDoIcone(linha),
                                  attrs: {
                                    name: linha.icone,
                                    size: _vm.TAMANHO_DO_ICONE_DA_LINHA,
                                    color: _vm.corDoIcone(linha)
                                  }
                                })
                              ],
                              1
                            )
                          ]
                        }
                      }
                    ],
                    null,
                    true
                  )
                },
                [_c("span", [_vm._v(_vm._s(linha.titulo))])]
              )
            ],
            1
          )
        }),
        0
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }